import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

// A QR code drawn into an <img> on connect, from the text on the element
// (the sell sheet's "Scan to join": the event's join link, 256 px, margin
// 1, shown at 96 px). Nothing about the link leaves the device.
export default class extends Controller {
  static targets = ["image"]
  static values = { text: String, width: { type: Number, default: 256 }, margin: { type: Number, default: 1 } }

  async connect() {
    try {
      this.imageTarget.src = await QRCode.toDataURL(this.textValue, { width: this.widthValue, margin: this.marginValue })
    } catch {
      this.imageTarget.alt = "QR code unavailable"
    }
  }
}
